import Logger from '@owc-utils/common/Logger';

const isShimmLoaded = Boolean(globalThis.importShim);
Logger.log(`Shimmed imports are loaded: ${isShimmLoaded}`);

export default async function ensureDynamicImport<T>(moduleName: string): Promise<T> {
  if (isShimmLoaded) {
    Logger.log('shimmed import', moduleName);
    return await importShim<T>(moduleName);
  } else {
    Logger.log('importing module', moduleName);
    return await importModule(moduleName);
  }
}

export function isShimLoaded(): boolean {
  return isShimmLoaded;
}
